"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getESTDate = void 0;
/**
 * Returns the corresponding date in EST
 * @public
 *
 * @param today - Date from where to calculate EST hour
 *
 * @returns Date in EST
 */
function getESTDate(today) {
    const millisecondsInAMinute = 60 * 1000;
    const utcDate = new Date(today.getTime() + today.getTimezoneOffset() * millisecondsInAMinute);
    const estTimezoneOffsetMinutes = -300;
    return new Date(utcDate.getTime() + estTimezoneOffsetMinutes * millisecondsInAMinute);
}
exports.getESTDate = getESTDate;
//# sourceMappingURL=get-EST-date.js.map